import { Injectable, SecurityContext } from '@angular/core';
import { DownloadServiceModel } from '../../models/LocalServiceModels/DownloadServiceModel';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class FileDownloaderService {

  constructor(private sanitizer: DomSanitizer) { }

  public downloadFileSingle(data: DownloadServiceModel, extension: string) {

    let mimeType: string;
    switch (extension) {
      case 'jpeg':
        mimeType = 'image/jpeg'
        extension = ".jpeg";
        break;
    }
    this.createrDownloadLink(data, mimeType, extension);
  }

  public createrDownloadLink(data: DownloadServiceModel, mimeType: string, extension: string) {
    if (data.FileData != null) {
      var blob = this.b64toBlob(data.FileData, mimeType);
      var a = document.createElement("a");
      const sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, a.outerHTML);
      if (sanitizedValue) {
        const template = document.createElement('template');
        template.innerHTML = sanitizedValue.trim();
        const parsedElement = template.content.firstChild;
        if (parsedElement) {
          document.documentElement.appendChild(parsedElement);
        }
      }
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = data.FileName + extension;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  private b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
